import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { getValidationMessage } from '../utils/getValidationMessage';
export const InputValidation = ({ error, validation }) => {
    const errorMessage = useMemo(() => typeof error === 'string'
        ? error
        : !!(error === null || error === void 0 ? void 0 : error.message)
            ? error === null || error === void 0 ? void 0 : error.message
            : getValidationMessage(error === null || error === void 0 ? void 0 : error.type, validation), [error, validation]);
    if (!error)
        return null;
    return (_jsx(Form.Control.Feedback, Object.assign({ className: 'd-block', type: 'invalid' }, { children: errorMessage })));
};
